<h2 class="heading--2" i18n="@@pastMealHeading">Past meal plans</h2>

<cdx-ticker [list]="dates" [startAtEnd]="true" (next)="handleNavClick($event)" (prev)="handleNavClick($event)"></cdx-ticker>

<cdx-carousel2
  [name]="carouselName"
  [itemCount]="activeMealPlan?.meals.length"
  [columns]="columns"
  class="stamp-theme-grey"
>
  <cdx-carousel2-item
    *ngFor="let stamp of activeMealPlan.meals; let i = index;"
    [impressionTrackingEnabled]="true"
    [impressionArgs]="getRecipeImpressionArgs(stamp.recipe, i)"
  >
    <recipe-stamp-basic [stamp]="stamp" [link]="getRecipePath(stamp)" (saveOrUnsaveRecipe)="saveOrUnsaveRecipe.emit($event)"></recipe-stamp-basic>
  </cdx-carousel2-item>
</cdx-carousel2>

<button type="button" cdxButton (click)="addToNewMealPlan()" i18n="@@pastMealAddToPlanButton">Add to a new plan</button>